// src/pages/ProductoRegister.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../Config';

const ProductoRegister = () => {
  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [categoriaId, setCategoriaId] = useState('');
  const [iva, setIva] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();
  const [stockMinimo, setStockMinimo] = useState(0);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/categorias`);
        setCategorias(response.data);
      } catch (error) {
        console.error('Error al cargar categorías', error);
      }
    };
    fetchCategorias();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/productos`, {
        nombre,
        precio,
        descripcion,
        tipoIva: iva, // CAMBIADO: de "iva" a "tipoIva"
        categoria: { id: categoriaId },
        stockMinimo
      });


      setMensaje('✅ Producto registrado correctamente');
      setNombre('');
      setPrecio('');
      setDescripcion('');
      setCategoriaId('');
      setIva('');
      setTimeout(() => navigate('/admin-productos'), 1500);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al registrar producto');
    }
  };

  const handleCancel = () => {
    navigate('/admin-productos');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Registrar Producto</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-1">Nombre:</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="mb-4">
            <label className="block mb-1">Precio:</label>
            <input
              type="number"
              value={precio}
              onChange={(e) => setPrecio(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="mb-4">
  <label className="block mb-1">Stock mínimo:</label>
  <input
    type="number"
    value={stockMinimo}
    onChange={(e) => setStockMinimo(parseInt(e.target.value))}
    min={0}
    required
    className="w-full border px-3 py-2 rounded"
  />
</div>

          <div className="mb-4">
            <label className="block mb-1">Descripción:</label>
            <textarea
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded"
              rows={3}
            />
          </div>

          <div className="mb-4">
            <label className="block mb-1">IVA:</label>
            <select
              value={iva}
              onChange={(e) => setIva(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Seleccionar tipo de IVA</option>
              <option value="EXENTO">Exento</option>
              <option value="IVA_5">5%</option>
              <option value="IVA_10">10%</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block mb-1">Categoría:</label>
            <select
              value={categoriaId}
              onChange={(e) => setCategoriaId(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Seleccionar categoría</option>
              {categorias.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-between">
            <button
              type="submit"
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Guardar
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancelar
            </button>
          </div>
        </form>

        {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
      </div>
    </div>
  );
};

export default ProductoRegister;